import PropTypes from 'prop-types';
import React from 'react';

import Carousel, { CarouselNavigation, CarouselSlide } from '$partials/ui/carousel.jsx';
import { CarouselProvider } from '$contexts/carousel.jsx';

import { PersonItem } from '$partials/listings';
import { IconArrowRight } from '$partials/icons';
import { formatUrlWithActiveFund } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const PeopleCarousel = ({
    ctaLabel,
    ctaLink,
    items,
    sidebarTitle,
}) => {

    return (
        <div className='max-w-container py-100 md:pt-120'>
            <div className='flex'>
                <CarouselProvider swiperConfig={{
                    slidesPerGroup: 1,
                    breakpoints: {
                        600: {
                            slidesPerGroup: 2,
                        },
                        1024: {
                            slidesPerGroup: 3,
                        },
                    }
                }}>

                    {/* Left Sidebar */}
                    <div className='w-sidebar flex-shrink-0'>
                        <div className='flex flex-col items-center'>
                            <h2 className='type-style-8 inline-block align-middle rotate-180 writing-mode-vertical-rl'>
                                {sidebarTitle}
                            </h2>
                            <CarouselNavigation
                                buttonClassName='bg-grey'
                                className='flex flex-col mt-30'/>
                        </div>
                    </div>

                    {/* Body */}
                    <div className='relative flex-initial overflow-hidden sm:w-full'>
                        <div className='layout-negative-margin'>
                            <Carousel className='flex transition-transform h-full ml-0 mr-0 flex-shrink-0'>
                                {items?.length > 0 && (
                                    items.map(({page: item}, idx) => {
                                        return (
                                            <CarouselSlide
                                                className='flex flex-wrap w-10/12 sm:w-5/12 md:w-3/12 flex-shrink-0 layout-item-padding'
                                                index={idx}
                                                key={`${item?.id}-image-${idx}`}>
                                                <div className='w-full sm:w-5/6'>
                                                    <PersonItem
                                                        className='w-full flex-shrink-0 flex-grow-1'
                                                        style='carousel'
                                                        {...item} />
                                                </div>
                                            </CarouselSlide>
                                        );
                                    })
                                )}
                            </Carousel>
                        </div>
                    </div>
                </CarouselProvider>
            </div>

            <div className='flex'>
                {/* Left sidebar */}
                <div className='w-sidebar'>
                    <div className='flex flex-col items-center'>
                    </div>
                </div>
                {/* Body */}
                <div className='mt-30 sm:mb-20'>
                    {(ctaLink?.url) &&
                        <a
                            className='bg-grey px-12 py-5 sm:py-8 rounded-3xl h-fit arrow-button'
                            href={formatUrlWithActiveFund(ctaLink.url)}>
                            <span className='inline-flex items-center gap-5'>
                                {ctaLabel || 'All founders'}
                                <IconArrowRight />
                            </span>
                        </a>
                    }
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    ctaLabel: PropTypes.string,
    ctaLink: PropTypes.shape({
        url: PropTypes.string,
    }),
    items: PropTypes.array,
    sidebarTitle: PropTypes.string,
};


PeopleCarousel.propTypes = propTypes;

export default PeopleCarousel;
